import React from "react";

import { Outlet } from "react-router-dom";

import Box from "@mui/material/Box";

import Navbar from "./Navbar";

import FistoProvider from "../contexts/FistoContext";
import ConfirmProvider from "../contexts/ConfirmContext";
import ReasonProvider from "../contexts/ReasonContext";
import Sidebar from "./sidebar/Sidebar";
import ChatbotContainer from "./FistoChatbot";

const Layouts = () => {
  return (
    <React.Fragment>
      <Sidebar />
      <Box className="fsto">
        <Navbar />
        <FistoProvider>
          <ConfirmProvider>
            <ReasonProvider>
              <Outlet />
              <ChatbotContainer />
            </ReasonProvider>
          </ConfirmProvider>
        </FistoProvider>
      </Box>
    </React.Fragment>
  );
};

export default Layouts;
